<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'COMPOUND_SETTINGS' }
  ]"
></breadcrumbs>

<page-header title="COMPOUND_SETTINGS"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label
        class="label"
        translationEditableDirective="COMPOUND_LICENSE_TEMPLATE"
        >{{ 'COMPOUND_LICENSE_TEMPLATE' | translate }}</label
      >
      <div class="control">
        <ng-select
          class="is-small"
          [items]="templates"
          [multiple]="false"
          [closeOnSelect]="true"
          (change)="
            handleFieldChange($event?.id, 'SETTINGS_COMPOUNDS_TEMPLATE')
          "
          [ngClass]="{
            'is-danger': hasError('SETTINGS_COMPOUNDS_TEMPLATE')
          }"
          bindLabel="name"
          bindValue="id"
          [ngModelOptions]="{ standalone: true }"
          [ngModel]="getField(['SETTINGS_COMPOUNDS_TEMPLATE'])"
          [typeahead]="onTemplatesAutocomplete$"
        >
        </ng-select>
      </div>
      <p class="help is-danger" *ngIf="hasError('SETTINGS_COMPOUNDS_TEMPLATE')">
        {{ getError('SETTINGS_COMPOUNDS_TEMPLATE') }}
      </p>
    </div>
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="MIN_TAX">{{
        'MIN_TAX' | translate
      }}</label>
      <div class="control">
        <number-input
          name="SETTINGS_COMPOUNDS_MIN_TAX"
          step="0.1"
          (input)="
            handleFieldChange(
              $event?.target?.value,
              'SETTINGS_COMPOUNDS_MIN_TAX'
            )
          "
          [value]="getField(['SETTINGS_COMPOUNDS_MIN_TAX'])"
          [inputClass]="{
            'input is-small': true,
            'is-danger': hasError('SETTINGS_COMPOUNDS_MIN_TAX')
          }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SETTINGS_COMPOUNDS_MIN_TAX')">
        {{ getError('SETTINGS_COMPOUNDS_MIN_TAX') }}
      </p>
    </div>
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="MAX_TAX">{{
        'MAX_TAX' | translate
      }}</label>
      <div class="control">
        <number-input
          name="SETTINGS_COMPOUNDS_MAX_TAX"
          step="0.1"
          (input)="
            handleFieldChange(
              $event?.target?.value,
              'SETTINGS_COMPOUNDS_MAX_TAX'
            )
          "
          [value]="getField(['SETTINGS_COMPOUNDS_MAX_TAX'])"
          [inputClass]="{
            'input is-small': true,
            'is-danger': hasError('SETTINGS_COMPOUNDS_MAX_TAX')
          }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('SETTINGS_COMPOUNDS_MAX_TAX')">
        {{ getError('SETTINGS_COMPOUNDS_MAX_TAX') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      (click)="onSubmit($event)"
      translationEditableDirective="SAVE"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
</div>
